import * as client from "_graphql-types";
import * as types from "./types";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(sdk: Sdk, params: types.GetListParams<client.RightOfExtensionEnumSortEnum>) {
  const {
    pagination: { page, perPage },
    sort: { field, order }
  } = params;

  const {
    rightOfExtensionEnumList: { items: data, total }
  } = await sdk.getListRightOfExtensionEnum({
    page: {
      offset: (page - 1) * perPage,
      limit: perPage
    },
    sort: [{ field, order }]
  });

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { rightOfExtensionEnum: data } = await sdk.getOneRightOfExtensionEnum({
    id
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(Number);

  const {
    rightOfExtensionEnumMany: data
  } = await sdk.getManyRightOfExtensionEnum({
    ids
  });

  return {
    data,
  };
}


/*********************************************************************/
export const rightOfExtensionEnum = types.dataProvider({
  getList,
  getOne,
  getMany
});